import React from 'react';
var useDynamicScript = function (args) {
    var _a = React.useState(false), ready = _a[0], setReady = _a[1];
    var _b = React.useState(false), failed = _b[0], setFailed = _b[1];
    React.useEffect(function () {
        if (!args.url) {
            return;
        }
        var element = document.createElement('script');
        element.src = args.url;
        element.type = 'text/javascript';
        element.async = true;
        setReady(false);
        setFailed(false);
        element.onload = function () {
            console.log("Dynamic Script Loaded: ".concat(args.url));
            setReady(true);
        };
        element.onerror = function () {
            console.error("Dynamic Script Error: ".concat(args.url));
            setReady(false);
            setFailed(true);
        };
        document.head.appendChild(element);
        return function () {
            console.log("Dynamic Script Removed: ".concat(args.url));
            document.head.removeChild(element);
        };
    }, [args.url]);
    return {
        ready: ready,
        failed: failed,
    };
};
export default useDynamicScript;
